import { useEffect, useState } from 'react';

import { useApolloClient } from '@apollo/client';
import { useRouter } from 'next/router';
import { useSWRConfig } from 'swr';

import { getBuilderCollectionContent } from './getBuilderCollectionContent';
import { useProductGridDefaultParameters } from './useProductGridDefaultParameters';

export function useBuilderCollection({
  options,
  serverSideData,
  isTabGrid,
  automaticSizeFiltering,
}) {
  const [clientCollectionContent, setClientCollectionContent] = useState();
  const productGridParameters = useProductGridDefaultParameters();
  const { cache } = useSWRConfig();
  const { query } = useRouter();
  const apolloClient = useApolloClient();

  useEffect(() => {
    if (!apolloClient) {
      return;
    }

    const builderCollectionContentParameters = {
      ...productGridParameters,
      options,
      query,
      isTabGrid,
      automaticSizeFiltering,
    };
    const key = `useBuilderCollection:${JSON.stringify(
      builderCollectionContentParameters
    )}`;
    builderCollectionContentParameters.apolloClient = apolloClient;
    const getCollectionContent = async () => {
      // only run this if the server side data was not set
      if (serverSideData) {
        return null;
      }

      const collectionContent = await getBuilderCollectionContent(
        builderCollectionContentParameters
      );
      setClientCollectionContent(collectionContent);
      cache.set(key, collectionContent);
    };

    // this is used to leverage the product listing cache if we want to use caching
    const cachedCollectionContent = cache.get(key);
    if (cachedCollectionContent) {
      setClientCollectionContent(cachedCollectionContent);
    } else {
      getCollectionContent();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, productGridParameters, serverSideData, apolloClient]);

  return clientCollectionContent;
}
